import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import dealer from "@/store/modules/forms/dealer";
import auth from "@/store/modules/forms/auth";
import uploads from "@/store/modules/forms/upload";
import message from "@/store/modules/forms/message";
import orders from "@/store/modules/forms/order";
import customers from "@/store/modules/forms/customer";
import employees from "@/store/modules/forms/employee";
import homeChart from "@/store/modules/forms/homeChart";
import commissions from "@/store/modules/forms/commissions";
import partner from "@/store/modules/forms/partner";
import reports from "@/store/modules/forms/reports";
import nampt from "@/store/modules/forms/nampt";
import featureFlag from "@/store/modules/forms/featureFlag";
import LogRocket from "logrocket";
import createPlugin from "logrocket-vuex";

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";
const logrocketPlugin = createPlugin(LogRocket);

export default new Vuex.Store({
  strict: debug,
  plugins: [
    createPersistedState({
      storage: window.sessionStorage,
    }),
    logrocketPlugin,
  ],
  modules: {
    message,
    auth,
    dealer,
    uploads,
    orders,
    customers,
    employees,
    homeChart,
    commissions,
    partner,
    reports,
    nampt,
    featureFlag,
  },
});
